var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.6667C4 12.2985 4.29848 12 4.66667 12H27.3333C27.7015 12 28 12.2985 28 12.6667V28.6667C28 29.0349 27.7015 29.3333 27.3333 29.3333H4.66667C4.29848 29.3333 4 29.0349 4 28.6667V12.6667Z",
    fill: "url(#paint0_linear_13505_14946)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 21.3333C13.334 19.8605 14.5279 18.6666 16.0007 18.6666C17.4734 18.6666 18.6673 19.8605 18.6673 21.3333V29.3333H13.334V21.3333Z",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2617 3.33331H8.73971C8.27998 3.33331 7.85269 3.58494 7.60904 3.99915L1.97154 13.5829C1.69402 14.0547 2.01325 14.6666 2.53687 14.6666H29.4645C29.9882 14.6666 30.3074 14.0547 30.0299 13.5829L24.3924 3.99915C24.1487 3.58494 23.7214 3.33331 23.2617 3.33331Z",
    fill: "url(#paint1_linear_13505_14946)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5286 10.8764L12 14.6666H20L16.4714 10.8764C16.2111 10.5967 15.7889 10.5967 15.5286 10.8764Z",
    fill: "#E6E5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88954 18.6666C7.58272 18.6666 7.33398 18.9154 7.33398 19.2222V21.4444C7.33398 21.7512 7.58272 22 7.88954 22H10.1118C10.4186 22 10.6673 21.7512 10.6673 21.4444V19.2222C10.6673 18.9154 10.4186 18.6666 10.1118 18.6666H7.88954Z",
    fill: "#8E8CEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8895 18.6666C21.5827 18.6666 21.334 18.9154 21.334 19.2222V21.4444C21.334 21.7512 21.5827 22 21.8895 22H24.1118C24.4186 22 24.6673 21.7512 24.6673 21.4444V19.2222C24.6673 18.9154 24.4186 18.6666 24.1118 18.6666H21.8895Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13505_14946",
    x1: 10,
    y1: 23.7619,
    x2: 15.3765,
    y2: 16.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D9D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703225,
    stopColor: "#E6E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13505_14946",
    x1: 19.0562,
    y1: 8.37035,
    x2: 20.9602,
    y2: 5.9064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.11d9fd0b2ad184794f0986197f0b416b.svg";
export { ForwardRef as ReactComponent };